const ListTable = require('app/ui/list/Table');
const ConfirmModal = require('app/ui/modal/Confirm');
const GraphQLMutation = require('app/graphql/Mutation');

const CreateModal = require('app/supplier/CreateModal');

class ListView {
    defaultOptions() {
        return {
            'selector': '.view-supplier-list',
            'tableContainerSelector': '.supplier-list-container',
            'filterFormSelector': '.supplier-list-search-form',

            'supplierShowBaseUrl': window.App.get('supplierShowBaseUrl'),
            'supplierStatBaseUrl': window.App.get('supplierStatBaseUrl'),
            'supplierRestaurantBaseUrl': window.App.get('supplierRestaurantBaseUrl'),
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);
        this.onClickCreate = this.onClickCreate.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.$tableContainer = $(this.settings.tableContainerSelector,this.$container);
        this.$btnCreate = $('.btn-supplier-create');

        this.initialize();
    }

    initialize() {
        var self = this;

        this.initializeListTable();
        this.bindEvents();
    }


    refresh(){
        this.table.refresh();
    }


    initializeListTable(){
        var self = this;

        let fields = [
            'id',
            'createdAt',
            'name',
            'status',
        ];

        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped supplier-list',
            'id': 'list-suppliers',
            'length': 50,
            'graphQL': {
                'queryType': 'suppliers',
                'fields': fields,
                'parameters': this.buildGraphQLParameters,

            },
            'columns': [
                {
                    'name': 'createdAt',
                    'label': window.translate('supplier.createdAt.label'),
                    'orderType': 'createdAt',
                    'class': 'supplier-createdAt',
                    'render': function(item,index){
                        return window.formatDate(item.node.createdAt,window.translate('momentDateFormat.fullDay'));
                    },
                },
                {
                    'name': 'name',
                    'label': window.translate('supplier.name.label'),
                    'ordered': true,
                    'orderType': 'name',
                    'orderDir': 'ASC',
                    'class': 'supplier-name',
                    'render': function(item,index){
                        return item.node.name;
                    },
                },
                {
                    'name': 'actions',
                    'label': '',
                    'class': 'supplier-actions',
                    'render': function(item,index){
                        let $list = $('<ul/>')
                        .addClass('list-inline btn-list-inline');

                        let btns = [];

                        let urlEdit = self.settings.supplierShowBaseUrl.replace('__ID__',item.node.id);
                        let $btnEdit = $('<a/>')
                        .attr('href',urlEdit)
                        .addClass('btn btn-link iframe fancy')
                        .attr('data-fancybox','')
                        .attr('data-type','iframe')
                        .attr('title',window.translate('supplier.actions.edit.label'))
                        .append(
                            $('<i/>')
                            .addClass('fas fa-edit')
                        );
                        btns.push($btnEdit);

                        let urlStat = self.settings.supplierStatBaseUrl.replace('__ID__',item.node.id);
                        let $btnStat = $('<a/>')
                        .attr('href',urlStat)
                        .addClass('btn btn-link iframe fancy')
                        .attr('data-fancybox','')
                        .attr('data-type','iframe')
                        .attr('title',window.translate('supplier.actions.stat.label'))
                        .append(
                            $('<i/>')
                            .addClass('fas fa-chart-line')
                        );
                        btns.push($btnStat);

                        let urlRestaurant = self.settings.supplierRestaurantBaseUrl.replace('__ID__',item.node.id);
                        let $btnRestaurant = $('<a/>')
                        .attr('href',urlRestaurant)
                        .addClass('btn btn-link iframe fancy')
                        .attr('data-fancybox','')
                        .attr('data-type','iframe')
                        .attr('title',window.translate('supplier.actions.restaurant.label'))
                        .append(
                            $('<i/>')
                            .addClass('fas fa-users')
                        );
                        btns.push($btnRestaurant);


                        let $btnToggleStatus = $('<button/>')
                        .attr('type','button')
                        .on('click',function(event){
                            self.onClickToggleStatus(item.node);
                        });
                        if(item.node.status == 2){
                            $btnToggleStatus
                            .attr('title',window.translate('supplier.actions.toggle.labelOff'))
                            .addClass('btn btn-link text-success')
                            .append(
                                $('<i/>')
                                .addClass('fas fa-power-off')
                            )
                        }else{
                            $btnToggleStatus
                            .attr('title',window.translate('supplier.actions.toggle.labelOn'))
                            .addClass('btn btn-link text-danger')
                            .append(
                                $('<i/>')
                                .addClass('fas fa-power-off')
                            )
                        }
                        btns.push($btnToggleStatus);

                        let $btnModalDelete = $('<button/>')
                        .attr('type','button')
                        .addClass('btn btn-link text-danger')
                        .attr('title',window.translate('supplier.actions.delete.label'))
                        .append(
                            $('<i/>')
                            .addClass('fas fa-trash')
                        )
                        .on('click',function(event){
                            self.onClickDelete(item.node);
                        });

                        for(var i in btns){
                            let $btn = btns[i];
                            $list.append(
                                $('<li/>')
                                .addClass('list-inline-item')
                                .append($btn)
                            );
                        }

                        return $list;
                    },
                },

            ]
        })
    }

    buildGraphQLParameters(){
        let filters = {
            'notStatus': 3 //deleted
        };

        let orderBy = 'name';
        let dir = "ASC";
        let parameters = {
            'filter' : filters,

            'orderBy': orderBy,
            'dir': dir,
        };


        return parameters;
    }

    bindEvents(){
        this.$btnCreate.on('click',this.onClickCreate)
    }

    onClickCreate(event){
        var self = this;
        event.preventDefault();
        event.stopPropagation();
        let modal = new CreateModal({
            'onSuccess': function(data){
                let supplier = data.supplier;
                let url = self.settings.supplierShowBaseUrl.replace('__ID__',supplier.id);
                window.redirect(url);
            }
        });
    }

    onClickToggleStatus(supplier){
        var self = this;
        if(supplier.status == 2){
            return this.proceedToggle(supplier);
        }

        let $content = $('<div/>')
        .append(
            $('<h5/>')
            .append(window.translate('supplier.actions.toggle.confirm.title'))
        )
        .append(
            $('<div/>')
            .append(window.translate('warning')+' !')
        )
        .append(
            $('<ul/>')
            .addClass('text-danger')
            .append(
                $('<li/>')
                .append(window.translate('supplier.actions.toggle.confirm.supplierProductsStatusChanged'))
            )
            .append(
                $('<li/>')
                .append(window.translate('supplier.actions.toggle.confirm.restaurantProductStatusChanged'))
            )
            .append(
                $('<li/>')
                .append(window.translate('supplier.actions.toggle.confirm.restaurantProductVisibilityChanged'))
            )
        );

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function(event,modal){
                self.proceedToggle(supplier)
            },
            'onCancel': function(event,modal){
            }
        })
        confirmModal.show();
    }

    proceedToggle(supplier,confirmModal){
        var self = this;

        let value = false;
        if(supplier.status == 2){
            value = true;
        }

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'supplier': {
                'value': supplier.id,
                'type': 'Int!'
            },
            'enable':{
                'value': value,
                'type': "Boolean!",
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "SubmitSupplierStatus",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.refresh();
            },
            'error': function(message, xhr){
                window.notify(message,"error");
            },
            'after': function(){
                if(confirmModal){
                    confirmModal.dispose();
                }
                //do nothing
            }
        });
        mutation.execute();

    }

    onClickDelete(supplier){
        var self = this;

        let $content = $('<div/>')
        .append(
            $('<div/>')
            .append(window.translate('supplier.actions.delete.confirm',{'%supplierName%':supplier.name}))
        )
        .append(
            $('<div/>')
            .addClass('text-danger')
            .append(window.translate('supplier.actions.delete.warning'))
        );

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function(event,modal){
                self.proceedDelete(supplier,modal)
            },
            'onCancel': function(event,modal){
            }
        })
        confirmModal.show();

    }

    proceedDelete(supplier,confirmModal){

        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'supplier': {
                'value': supplier.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteSupplier",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                confirmModal.dispose();
                self.refresh();
            },
            'error': function(message, xhr){
                confirmModal.dispose();
                window.notify(message,"error");
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }
}

module.exports = ListView;

